import React from 'react';
import { useTranslation } from 'react-i18next';
import { currentLang } from './docText';

// HOLIDAYALLOW: "12.5 days", "12,5 jours", "1 day". French takes the singular below 2.
export function daysText(t, value, working) {
  const lang = currentLang();
  const fr = String(lang).startsWith('fr');
  const size = Math.abs(value);
  const one = size === 1 || (fr && size < 2);
  const unit = t(`leaveForm.${working ? 'balanceWorkingDay' : 'balanceDay'}${one ? 'One' : 'Many'}`);
  const number = fr ? String(value).replace('.', ',') : String(value);
  return `${number} ${unit}`;
}

// HOLIDAYALLOW: the three figures of a Holiday request, for each year it counts in. Shared by the
// employee's form and the manager's approval screen; every number comes from the server.
export default function HolidayBalanceFigures({ years, color, testId }) {
  const { t } = useTranslation();
  if (!Array.isArray(years) || years.length === 0) return null;
  const line = { margin: '2px 0 0', fontSize: '12.5px', color };
  return (
    <div data-testid={testId}>
      {years.map(y => (
        <div key={y.year} style={{ marginTop: '6px' }}>
          <p style={{ ...line, fontWeight: 600 }}>{t('leaveForm.balanceYear', { year: y.year })}</p>
          <p style={line}>{t('leaveForm.balanceRequest', { days: daysText(t, y.request_days, true) })}</p>
          <p style={line}>{t('leaveForm.balanceBefore', { days: daysText(t, y.remaining_before) })}</p>
          <p style={line}>{t('leaveForm.balanceAfter', { days: daysText(t, y.remaining_after) })}</p>
        </div>
      ))}
    </div>
  );
}
